import { useForm } from "react-hook-form";
import { GenericComponent } from "../../components/GenericComponent";
import { Generico } from "../../components/Generico";
import { InfoCliente } from "../../models/matriz/InfoCliente";
import { InfoClienteService } from "../../service/matriz/InfoClienteService";
import { useEffect, useRef, useState } from "react";
import { InputComponent } from "../../components/InputComponent";
import { confirmDialog } from "primereact/confirmdialog";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { Card } from "primereact/card";
import { Toolbar } from "primereact/toolbar";
import { Dialog } from "primereact/dialog";
import { Busqueda } from "./Busqueda";
import { DetalleProveedor } from "./DetalleProveedor";
import { useToken } from "../../components/useToken";
import { MonitoreoService } from "../../service/monitoreo/MonitoreoService";
import { ConfiguracionEmpresaCliente } from "./ConfiguracionEmpresaCliente";
import { PlantillaColor } from "./PlantillaColor";
import { TablaDinamica } from "../../components/TablaDinamica";
import { useLazyParams } from "../../hooks/useLazyParams";
import { Column } from "primereact/column";
import { Menu } from "primereact/menu";
import { FileUpload } from "primereact/fileupload";

export const Proveedor = ({ tipo }) => {
    const [siEmpresa, setSiEmpresa] = useState(true);
    const [catalogo, setCatalogo] = useState(null);
    const omodel = new InfoCliente({ formularioMatriz: catalogo?.formularioMatriz, siEmpresa });
    const generic = new GenericComponent();
    const clienteSrv = new InfoClienteService();
    const monitoreoSrv = new MonitoreoService();
    const defaultValues = generic.default(omodel.model);
    const { funcMessageBlobError, downloadPdf, limpiarNombre } = Generico();
    const { control, formState: { errors }, handleSubmit, reset, setValue, setError, getValues } = useForm({ defaultValues });
    const [permss, setPermss] = useState(null);
    const toast = useRef(null);
    const [dialogCliente, setDialogCliente] = useState(false);
    const [dialogPerfil, setDialogPerfil] = useState(false);
    const [dialogColor, setDialogColor] = useState(false);
    const [matriz, setMatriz] = useState(null);
    const [dialogBusqueda, setDialogBusqueda] = useState(false);
    const [dialogNatural, setDialogNatural] = useState(false);
    const [selectedEmpresa, setSelectedEmpresa] = useState(null);
    const [lista, setLista] = useState(null);
    const { getRol } = useToken();
    const [opcion, setOpcion] = useState(null);
    const [siFormulario, setSiFormulario] = useState(false);
    const [dialogConfig, setDialogConfig] = useState(false);
    const { inDrop, inText, inCalendar, inAutocomplete } = InputComponent({ omodel, generic, errors, control, permss, id: getValues('id') });
    const [diasMaxDescargaReporte, setDiasMaxDescargaReporte] = useState(31);
    const tablaEstado = useLazyParams({ modelo: omodel.model });
    const menuRef = useRef(null);
    const [dialogCarga, setDialogCarga] = useState(false);
    const [archivo, setArchivo] = useState(null);
    const [load, setLoad] = useState(false);
    let fileRef = useRef(null);
    const [loadExcelPlantilla, setLoadExcelPlantilla] = useState(false);
    const [dialogDescarga, setDialogDescarga] = useState(false);

    useEffect(() => {
        loadLazyData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tablaEstado.lazyParams]);

    const loadLazyData = () => {
        tablaEstado.setLoading(true);
        let _lazyParams = { ...tablaEstado.lazyParams };
        delete _lazyParams.rtipo;
        if (permss == null) {
            _lazyParams.rtipo = 'permiso';
        }
        if (getRol()) {
            _lazyParams.rol = getRol();
        }
        clienteSrv.lista({ lazyEvent: JSON.stringify(_lazyParams) }, tipo).then(res => {
            tablaEstado.setTotalRecords(res.data.total);
            tablaEstado.setData(res.data.registros);
            if (catalogo == null) {
                setDiasMaxDescargaReporte(res.data.dias_max_descarga_reporte);
                setCatalogo(res.data.catalogos);
                setPermss(res.data.perss);
                setOpcion(res.data.opcion);
                setSiEmpresa(res.data.opcion === 'PRELAFIT' || res.data.opcion.includes('RIESGO_PROVEEDOR-LISTA-EMPRESA'));
            }
        }).finally(() => {
            tablaEstado.setLoading(false);
        });
    }

    const siOpcion = (strOpcion) => {
        return permss?.actualizar && (opcion === 'PRELAFIT' || opcion.includes(strOpcion));
    }

    const openNew = () => {
        setSiFormulario(false);
        reset(defaultValues);
        setDialogCliente(true);
    }

    const edit = () => {
        clienteSrv.consultar(matriz.id, getRol()?.id, tipo).then(res => {
            values(res.data);
        });
    }

    const values = (info) => {
        const _cliente = info.detalle;
        setSiFormulario((typeof _cliente?.idp === 'number') || typeof matriz?.idp === 'number');
        const lista = { tipo_identificacion: catalogo?.tipo_identificacion };
        if (permss?.actualizar && opcion === 'PRELAFIT') {
            if (_cliente['empresa'] != null) {
                _cliente['empresa'] = info.empresa;
                setSelectedEmpresa(info.empresa);
            }
        } else if (siOpcion('RIESGO_PROVEEDOR-LISTA-EMPRESA')) {
            lista.empresa = catalogo?.empresas;
        } else {
            delete _cliente?.empresa;
        }
        Object.keys(lista).forEach(function (key) {
            if (_cliente[key] != null) {
                lista[key].forEach(element => {
                    if (element.cat_id === _cliente[key]) {
                        _cliente[key] = element;
                    }
                });
            }
        });
        _cliente.fecha = generic.stringToDate(_cliente.fecha);
        if (typeof _cliente.tipo_identificacion === 'number') _cliente.tipo_identificacion = null;

        reset(generic.renewValues(_cliente, omodel.model));
        setDialogCliente(true);
        setDialogBusqueda(false);
    }

    const onSubmit = (data) => {
        data.fecha = generic.dateToString(data.fecha);
        setDialogBusqueda(false);
        setDialogNatural(false);
        if (getValues('id') == null) {
            clienteSrv.nuevo(data, tipo).then(res => {
                generic.funcSuccess(res, toast);
                setDialogCliente(false);
                tablaEstado.refreshData();
            }).catch(error => {
                if (!error.response?.data?.errors && error.response?.data?.message) {
                    error.response.data.errors = {
                        empresa: error.response.data.message
                    };
                }
                generic.funcError(error, toast, setError);
            });
        } else {
            clienteSrv.editar(data, tipo).then(res => {
                generic.funcSuccess(res, toast);
                tablaEstado.refreshData();
                setDialogCliente(false);
            }).catch(error => {
                if (!error.response?.data?.errors && error.response?.data?.message) {
                    error.response.data.errors = {
                        empresa: error.response.data.message
                    };
                }
                generic.funcError(error, toast, setError);
            });
        }
    }

    const volverBorrador = () => {
        confirmDialog({
            message: '¿Está seguro de volver a borrador?',
            header: 'Confirmar',
            icon: 'pi pi-info-circle',
            acceptClassName: 'p-button-danger',
            acceptLabel: 'Si',
            rejectLabel: 'No',
            accept: () => {
                clienteSrv.volverBorrador(matriz.id, tipo).then(res => {
                    generic.funcSuccess(res, toast);
                    tablaEstado.refreshData();
                }).catch(error => {
                    generic.funcDeleteError(error, toast);
                });
            }
        });
    }

    const deleteItem = () => {
        confirmDialog({
            message: '¿Esta seguro de eliminar la matriz?',
            header: 'Confirmar',
            icon: 'pi pi-info-circle',
            acceptClassName: 'p-button-danger',
            acceptLabel: 'Si',
            rejectLabel: 'No',
            accept: () => {
                clienteSrv.eliminar(matriz.id, tipo).then(res => {
                    generic.funcSuccess(res, toast);
                    tablaEstado.refreshData();
                }).catch(error => {
                    generic.funcDeleteError(error, toast);
                });
            }
        });
    }

    const abrirDescargaPlantilla = () => {
        reset(defaultValues);
        setSelectedEmpresa(null);
        setDialogDescarga(true);
        const esAdmin = opcion === 'PRELAFIT';
        if (!esAdmin && catalogo?.empresas?.length === 1) {
            setValue('empresa', catalogo.empresas[0]);
        }
    };

    const subir = () => {
        setArchivo(null);
        setSelectedEmpresa(null);
        setDialogCarga(true);
        reset(defaultValues);
        const esAdmin = opcion === 'PRELAFIT';
        if (!esAdmin && catalogo?.empresas?.length === 1) {
            setValue('empresa', catalogo.empresas[0]);
        }
    }

    const startContent = (
        <>
            {permss?.crear && <Button icon="pi pi-plus" className="mr-2" tooltip="Nueva matriz" onClick={openNew} />}
            {siOpcion('RIESGO_PROVEEDOR-PJ-BVG') && <Button icon="pi pi-search" className="mr-2" tooltip="Búsqueda Declaración Persona Jurídica: Proveedor" onClick={() => setDialogBusqueda(true)} />}
            {siOpcion('RIESGO_PROVEEDOR-PN-BVG') && <Button icon="pi pi-search-plus" className="mr-2" tooltip="Búsqueda Declaración Persona Natural: Proveedor" onClick={() => setDialogNatural(true)} />}
            {siOpcion('RIESGO_PROVEEDOR-CONFIGURACION') && <Button icon="pi pi-cog" className="mr-2" tooltip="Configuración de parámetros"
                onClick={() => setDialogConfig(true)} />}
            {siOpcion('RIESGO_PROVEEDOR-COLORES') && <Button icon="pi pi-palette" className="mr-2" tooltip="Configuración de colores" onClick={() => setDialogColor(true)} />}
        </>
    );

    const endContent = (
        <>
            <div className="flex align-items-center gap-4">
                <div className="flex align-items-center gap-2 border-right-1 surface-border pr-4">
                    {siOpcion('RIESGO_PROVEEDOR-DESCARGAR-PLANTILLA') && (
                        <Button onClick={abrirDescargaPlantilla} className="p-button-secondary" tooltip="1. Descargar plantilla" tooltipOptions={{ position: 'top' }} icon="pi pi-download" />
                    )}
                    {siOpcion('RIESGO_PROVEEDOR-CARGAR-XLSX') && (
                        <Button icon="pi pi-file-excel" className="mr-2" tooltip="Cargar desde Excel (XLSX)" onClick={subir} />
                    )}
                </div>
                <div className="flex align-items-center gap-2">
                    {generic.rightToolbarTemplate(tablaEstado.data, omodel, 'Listado_matrices', 'LISTADO MATRICES', true, 'matriz/exportar/proveedor', diasMaxDescargaReporte)}
                </div>
            </div>
        </>
    );

    const ejecutarDescargaPlantilla = () => {
        const empresa = getValues('empresa');

        setLoadExcelPlantilla(true);

        const params = { empresa_id: empresa?.cat_id ?? null, tipo_matriz: 'proveedor' };

        monitoreoSrv.generarDocumento('matriz/plantilla/descargar-plantilla', params).then((res) => {
            generic.downloadPdf(res.data, 'plantilla_matrices_proveedor.xlsx');
            toast.current.show({ severity: 'success', summary: 'Éxito', detail: `Plantilla descargada`, life: 6000 });
            setDialogDescarga(false);
        }).catch((error) => {
            generic.funcErrorHibrida(error, toast, setError);
        }).finally(() => {
            setLoadExcelPlantilla(false);
        });
    };

    const limpiarArchivo = () => {
        setArchivo(null);
        if (fileRef && fileRef.clear) {
            fileRef.clear();
        }
    };

    const subida = () => {
        if (archivo === null) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Debe seleccionar el archivo.', life: 3000 });
            return;
        }

        const formData = new FormData();
        formData.append('file', archivo, archivo.name);
        formData.append('tipo', tipo);
        // formData envía null como string, por lo que falla nullable en laravel, no agregamos la clave si no existe
        const empresaId = getValues('empresa')?.cat_id;
        if (empresaId) formData.append('empresa', empresaId);
        const tipoNegocioId = getValues('tipo_negocio')?.cat_id;
        if (tipoNegocioId) formData.append('tipo_negocio', tipoNegocioId);
        setLoad(true);
        clienteSrv.uploadDownload(formData, 'matriz/cliente/cargar').then(res => {
            const _consulta = res.headers['x-consulta'];
            if (!_consulta) {
                res.data.text().then(text => {
                    const _inf = JSON.parse(text);
                    generic.funcSuccess(_inf, toast);
                });
            } else {
                const url = window.URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', "reporte_errores.xlsx"); // o usa nameReport
                document.body.appendChild(link);
                link.click();
                link.remove();
            }
            setDialogCarga(false);
            setArchivo(null);
            tablaEstado.refreshData();
        }).catch(error => {
            generic.funcDeleteError(error, toast, setError);
        }).finally(() => {
            setLoad(false);
        });
    }

    const generarReporte = () => {
        tablaEstado.setLoading(true);
        const nombreArchivo = `Matriz Proveedor - ${limpiarNombre(matriz.nombres)}.pdf`;
        clienteSrv.descargar(matriz?.id, tipo).then(res => {
            downloadPdf(res, nombreArchivo);
        }).catch(error => {
            funcMessageBlobError('Asegúrese de ingresar y guardar la información antes de generar el reporte.', error, toast);
        }).finally(() => {
            tablaEstado.setLoading(false);
        });
    }

    const itemsMenu = () => {
        const items = [];
        if (permss?.actualizar && (!matriz?.nemonico || matriz?.nemonico !== 'FINALIZADO'))
            items.push({ label: 'Editar información de inicio', icon: 'pi pi-pencil', command: () => { edit() } });
        if (permss?.actualizar && (!matriz?.nemonico || matriz?.nemonico !== 'FINALIZADO'))
            items.push({ label: 'Contenido de la matriz', icon: 'pi pi-qrcode', command: () => { setDialogPerfil(true) } });
        if (permss?.consultar && matriz?.nemonico === 'FINALIZADO')
            items.push({ label: 'Imprimir matriz Análisis a PDF', icon: 'pi pi-print', command: () => { generarReporte() } });
        if (permss?.eliminar && (!matriz?.nemonico || matriz?.nemonico !== 'FINALIZADO'))
            items.push({ label: 'Eliminar', icon: 'pi pi-trash', command: () => { deleteItem() } });
        if (matriz?.nemonico === 'FINALIZADO' && permss?.actualizar && siOpcion('RIESGO_PROVEEDOR-VOLVER-A-BORRADOR')) {
            items.push({ label: 'Volver a borrador', icon: 'pi pi-undo', command: () => { volverBorrador() } });
        }

        return [{ label: 'Opciones', items: items }];
    }

    const seleccionar = (data) => {
        values({
            detalle: {
                fecha: data?.fecha,
                tipo_identificacion: data?.tipo_identificacion,
                identificacion: data?.identificacion,
                nombres: data?.razon_social,
                idp: data?.id,
                tipo: dialogBusqueda === true ? 'juridico' : 'natural',
                empresa: {
                    cat_id: data.empresa_id,
                    nombre: data.empresa_nombre
                }
            },
            empresa: {
                cat_id: data.empresa_id,
                nombre: data.empresa_nombre
            },
        });
    }

    const cerrarDialog = () => {
        setDialogCliente(false);
    };

    const regresar = () => {
        setMatriz(null);
        setDialogPerfil(false);
        tablaEstado.refreshData();
    }

    const searchEmpresa = (event) => {
        if (!event.query.trim().length) {
            setLista([...lista]);
        }
        else {
            monitoreoSrv.consultar(event.query.toLowerCase(), 'administracion/empresa-buscar/razon').then(data => {
                setLista(data);
            });
        }
    }

    const accionesTemplate = (rowData) => {
        return (
            <Button icon="pi pi-caret-down" type="button" className="p-button-rounded p-button-success mr-2" title="Opciones/Acciones" aria-controls="popup_menu" aria-haspopup
                onClick={(event) => { setMatriz(rowData); menuRef.current.toggle(event); }} />
        );
    };

    const ColumnaAcciones = (
        <Column header="Acciones" body={accionesTemplate} style={{ width: '6rem', textAlign: 'center' }} />
    );

    const fileUploadHandler = ({ files }) => {
        const [file] = files;
        const size = parseInt(process.env.REACT_APP_PEP_SIZE);
        if (file.size > size) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Tamaño máximo del archivo es: ' + (size / 1000) + " Kb", life: 3000 });
        }
        else {
            setArchivo(file);
        }
        fileRef?.clear();
    }

    const selectFile = (e) => {
        const size = parseInt(process.env.REACT_APP_PEP_SIZE);
        if (e.files.length <= 0 || e.files[0].size > size) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Tamaño máximo del archivo es: ' + (size / 1000) + " Kb", life: 3000 });
        }
        else {
            setArchivo(e.files[0]);
        }
        fileRef?.clear();
    }

    return (
        <>
            <Toast ref={toast} />
            <Menu model={itemsMenu()} popup ref={menuRef} id="popup_menu" />
            {!dialogPerfil && <Card style={{ maxWidth: '100%', margin: 'auto' }}>
                <Toolbar className="mb-4" start={startContent} end={endContent}></Toolbar>
                <TablaDinamica modelo={omodel.model} estadoTabla={tablaEstado} datos={tablaEstado.data} totalRegistros={tablaEstado.totalRecords} dataKey="id" acciones={ColumnaAcciones} />
            </Card>}

            <Dialog visible={dialogCliente} header={getValues('id') == null ? "Nueva matriz" : "Editar matriz"} modal className="p-fluid modal-ssize"
                onHide={e => { setDialogCliente(false); }} style={{ maxWidth: '500px' }}>
                <br />
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="formgrid grid">
                        {inCalendar('fecha', { disabled: siFormulario }, 12)}
                        {inDrop('tipo_identificacion', catalogo?.tipo_identificacion, { lab: omodel.optionLabel, ne: siFormulario }, 6)}
                        {inText('identificacion', { readOnly: siFormulario ? 'readOnly' : '' }, 6)}
                        {inText('nombres', { readOnly: siFormulario ? 'readOnly' : '' }, 12)}
                        {permss?.actualizar && opcion === 'PRELAFIT' &&
                            inAutocomplete('empresa', selectedEmpresa, setSelectedEmpresa, lista, searchEmpresa, { lab: omodel.optionLabel, col: 12, noEsActividad: true })}
                        {permss?.actualizar && opcion.includes('RIESGO_PROVEEDOR-LISTA-EMPRESA') &&
                            inDrop('empresa', catalogo?.empresas, { lab: omodel.optionLabel, col: 12 }, 12)
                        }
                    </div>
                    {generic.buttonsForms(cerrarDialog)}
                </form>
            </Dialog>

            <Dialog visible={dialogBusqueda} header='BÚSQUEDA - INFORMACIÓN DE PERSONA JURÍDICA: Proveedor' modal className="p-fluid modal-ssize"
                onHide={e => setDialogBusqueda(false)} style={{ maxWidth: '900px' }}>
                <Busqueda opcion="persona-juridica-proveedor-matriz-bvg" permss={permss} toast={toast} seleccion={seleccionar} filtro={catalogo?.filtroMatriz} />
            </Dialog>

            <Dialog visible={dialogNatural} header='BÚSQUEDA - INFORMACIÓN DE PERSONA NATURAL: Proveedor' modal className="p-fluid modal-ssize"
                onHide={e => setDialogNatural(false)} style={{ maxWidth: '900px' }}>
                <Busqueda opcion="persona-natural-proveedor-matriz-bvg" permss={permss} toast={toast} seleccion={seleccionar} filtro={catalogo?.filtroMatriz} />
            </Dialog>

            <Dialog visible={dialogConfig} header='Configuración de parámetros' modal className="p-fluid modal-ssize"
                onHide={e => setDialogConfig(false)} style={{ width: '600px' }}>
                <ConfiguracionEmpresaCliente permss={permss} toast={toast} generic={generic} catalogo={catalogo} opcion={opcion} tipo="RIESGO_PROVEEDOR" />
            </Dialog>

            <Dialog visible={dialogColor} header="Colores" modal className="p-fluid modal-ssize dialog-personalizado"
                onHide={e => setDialogColor(false)} style={{ width: '800px' }}>
                <PlantillaColor generic={generic} permss={permss} toast={toast} catalogo={catalogo} funcionalidades={opcion} tipo={"RIESGO_PROVEEDOR"} />
            </Dialog>

            <Dialog visible={dialogDescarga} header="Plantilla de Matriz de Proveedor" modal className="p-fluid dialog-personalizado" onHide={() => setDialogDescarga(false)} style={{ maxWidth: '460px' }}>
                <div className="p-4">
                    <div className="flex align-items-start gap-3 mb-4">
                        <div className="flex-shrink-0 flex align-items-center justify-content-center border-round-lg" style={{ width: '52px', height: '52px', background: 'var(--blue-50)' }}>
                            <i className="pi pi-download text-3xl" style={{ color: 'var(--blue-700)' }}></i>
                        </div>
                        <div>
                            <h4 className="m-0 mb-1 text-900">Descargar Plantilla</h4>
                            <p className="m-0 text-color-secondary line-height-3 text-sm">
                                Seleccione la empresa para generar la plantilla con las columnas correspondientes.
                            </p>
                        </div>
                    </div>

                    {permss?.actualizar && (opcion === 'PRELAFIT' || opcion?.includes('RIESGO_PROVEEDOR-LISTA-EMPRESA')) && (
                        <div className="field mb-4">
                            {opcion === 'PRELAFIT' ? (
                                inAutocomplete('empresa', selectedEmpresa, setSelectedEmpresa, lista, searchEmpresa, { lab: omodel.optionLabel, col: 12, noEsActividad: true })
                            ) : (
                                inDrop('empresa', catalogo?.empresas, { lab: 'nombre', etiqueta: 'Empresa', showClear: true }, 12)
                            )}
                        </div>
                    )}

                    <div className="flex gap-2 w-full mt-2">
                        <Button label="Cancelar" icon="pi pi-times" className="p-button-text p-button-secondary w-full" onClick={() => setDialogDescarga(false)} disabled={loadExcelPlantilla} />
                        <Button label="Descargar" icon="pi pi-download" className="p-button-primary w-full" onClick={ejecutarDescargaPlantilla} loading={loadExcelPlantilla} />
                    </div>
                </div>
            </Dialog>

            <Dialog visible={dialogCarga} header="Carga de Matrices de Proveedor" modal className="p-fluid dialog-personalizado" onHide={() => setDialogCarga(false)} style={{ maxWidth: '460px' }}>
                <div className="p-4">

                    <div className="flex align-items-start gap-3 mb-4">
                        <div className="flex-shrink-0 flex align-items-center justify-content-center border-round-lg" style={{ width: '52px', height: '52px', background: 'var(--green-50)' }}>
                            <i className="pi pi-file-excel text-3xl" style={{ color: 'var(--green-700)' }}></i>
                        </div>
                        <div>
                            <h4 className="m-0 mb-1 text-900">Subir Plantilla Llena</h4>
                            <p className="m-0 text-color-secondary line-height-3 text-sm">
                                Seleccione la empresa y el archivo Excel (.xlsx) previamente llenado.
                            </p>
                        </div>
                    </div>

                    {permss?.actualizar && (opcion === 'PRELAFIT' || opcion?.includes('RIESGO_PROVEEDOR-LISTA-EMPRESA')) && (
                        <div className="field mb-4">
                            {opcion === 'PRELAFIT' ? (
                                inAutocomplete('empresa', selectedEmpresa, setSelectedEmpresa, lista, searchEmpresa, { lab: omodel.optionLabel, col: 12, noEsActividad: true })
                            ) : (
                                inDrop('empresa', catalogo?.empresas, { lab: 'nombre', etiqueta: 'Empresa', showClear: true }, 12)
                            )}
                        </div>
                    )}

                    {/* Zona de Archivo */}
                    <div className="field mb-4">
                        <label className="font-bold block mb-2 text-sm">Archivo Excel *</label>
                        {!archivo ? (
                            <FileUpload name="file" accept=".xlsx" maxFileSize={parseInt(process.env.REACT_APP_PEP_SIZE)}
                                uploadHandler={fileUploadHandler} mode="basic" customUpload chooseLabel="Seleccionar Archivo Excel"
                                onSelect={selectFile} ref={ref => { fileRef = ref }}
                                chooseOptions={{ icon: 'pi pi-fw pi-upload', className: 'p-button-outlined p-button-secondary w-full border-dashed' }}
                                className="w-full" tooltip={omodel.insCarga} />
                        ) : (
                            <div className="flex align-items-center justify-content-between p-3 border-1 border-green-300 border-round bg-green-50">
                                <div className="flex align-items-center gap-3">
                                    <i className="pi pi-file-excel text-green-600 text-2xl"></i>
                                    <div className="flex flex-column">
                                        <span className="text-green-800 font-medium text-sm">
                                            {archivo.name}
                                        </span>
                                        <span className="text-xs text-green-600">
                                            {(archivo.size / 1024 / 1024).toFixed(2)} MB
                                        </span>
                                    </div>
                                </div>
                                <Button icon="pi pi-times" className="p-button-rounded p-button-danger p-button-text p-button-sm m-0 p-2" onClick={limpiarArchivo} tooltip="Quitar archivo" tooltipOptions={{ position: 'top' }} disabled={load} type="button" />
                            </div>
                        )}
                    </div>

                    <div className="flex gap-2 w-full mt-2">
                        <Button label="Cancelar" icon="pi pi-times" className="p-button-text p-button-secondary w-full" onClick={() => setDialogCarga(false)} disabled={load} />
                        <Button label="Procesar Excel" icon="pi pi-cloud-upload" className="p-button-success w-full" onClick={subida} loading={load} disabled={!archivo} />
                    </div>
                </div>
            </Dialog>

            {dialogPerfil && <DetalleProveedor matrizId={matriz?.id} permss={permss} setDialogPerfil={setDialogPerfil} toast={toast} tipo={tipo} regresar={regresar} funcionalidades={opcion} />}
        </>
    )
}
